'use strict'

import render from './render/render'

export default render(typeof window !== 'undefined' ? window : null)
